import { Stack, Typography, useTheme } from "@mui/material";
import type { MalwareScanningResult } from "../../../../api/types/fileTypes";
import VerifiedShieldIcon from "@entrilia/shared/icons/VerifiedShieldIcon";

interface Props {
  scanResult: MalwareScanningResult;
}

const MalwareScanBadge = ({ scanResult }: Props) => {
  const { palette } = useTheme();

  if (scanResult === "Clean") {
    return (
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <VerifiedShieldIcon htmlColor={palette.success.light} />
        <Typography variant="caption" color="textSecondary">
          Scanned for malware
        </Typography>
      </Stack>
    );
  }

  if (scanResult === "Malicious") {
    return (
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <VerifiedShieldIcon color="error" />
        <Typography variant="caption" color="error">
          Malware detected
        </Typography>
      </Stack>
    );
  }

  return null;
};

export default MalwareScanBadge;
